export default "__VITE_ASSET__DbTn8Spi__"